<template>
  <FlexColumn full-width>
    <FlexRow align="end">
      <SimpleSelectField
          :value="value.occupation"
          :items="consts.jobOccupation"
          width="240px"
          label="職種"
          clearable
          @input="onChangeOccupation"
      />
      <SimpleSelectField
          :value="value.salary"
          :items="salaries"
          width="160px"
          :label="value.jobType === 'regular' ? '年収' : '時間単価'"
          clearable
          @input="onChangeSalary"
      />
      <SimpleSelectField
          :value="value.prefectures"
          :items="consts.prefectures"
          multiple
          width="280px"
          label="勤務地"
          clearable
          @input="onChangePrefectures"
      />
    </FlexRow>
    <FlexRow>
      <TextField
          :value="value.keyword"
          name="フリーワード"
          simple
          @input="onChangeKeyword"
          @enter="$emit('enter')"
      />
    </FlexRow>
  </FlexColumn>
</template>

<script>
import FlexColumn from "../atoms/FlexColumn";
import FlexRow from "../atoms/FlexRow";
import Button from "../atoms/Button";
import SimpleSelectField from "../atoms/SimpleSelectField";
import {mapGetters} from "vuex";
import TextField from "../atoms/TextField";
export default {
  name: "JobSearchConditions",
  components: {TextField, SimpleSelectField, Button, FlexRow, FlexColumn},
  props: {
    value: {
      type: Object
    }
  },
  computed: {
    ...mapGetters('system', ['consts']),
    salaries() {
      if (this.value.jobType === 'regular') {
        return [
          {label: "400万以上", value: 400},
          {label: "500万以上", value: 500},
          {label: "600万以上", value: 600},
          {label: "700万以上", value: 700},
          {label: "800万以上", value: 800},
          {label: "900万以上", value: 900},
          {label: "1000万以上", value: 1000},
        ]
      }
      return [
        {label: "1000円以上", value: 1000},
        {label: "2000円以上", value: 2000},
        {label: "3000円以上", value: 3000},
        {label: "4000円以上", value: 4000},
        {label: "5000円以上", value: 5000},
      ]
    }
  },
  methods: {
    onChangeOccupation(value) {
      this.$emit("input", {...this.value, occupation: value});
    },
    onChangeSalary (value) {
      this.$emit("input", {...this.value, salary: value});
    },
    onChangePrefectures (value) {
      this.$emit("input", {...this.value, prefectures: value});
    },
    onChangeKeyword (value) {
      this.$emit("input", {...this.value, keyword: value});
    },
  }
}
</script>

<style scoped>

</style>
